import createSDKRequest from '@api-sdk/createSDKRequest';
import toRequest from './toRequest';
import fromResponse from './fromResponse';

export default createSDKRequest({
  toRequest,
  fromResponse,
});
